enum NavigationType {
  Internal = 'Internal',
  Frame = 'Frame',
}

export default NavigationType;
